import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '../../images/logo.png'

class Footer extends React.Component {
  render() {
    return(
      <div className="footer-container">
        <Link className="link" to="">
          <div className="logo-placeholder">
            <img src={Logo}/>
            <a>Copyright © NewSource Product Ltd All rights reserved.</a>
          </div>
        </Link>
        <div className="button-holder">
          <Link className="link" to="/products">
            <div className="button-container">
              Products
              <div className="button-underline" />
            </div>
          </Link>
          <Link className="link" to="/contact">
            <div className="button-container">
              Contact Us
              <div className="button-underline" />
            </div>
          </Link>
        </div>
      </div>
    )
  }
}

export default Footer